var en = {
  TABLE_HEADER_SORT_ASC: 'Ascending Order',
  TABLE_HEADER_SORT_DESC: 'Descending Order',
  SEARCH_PLACEHOLDER: 'Search',
  TABLE_HEADER_FILTER_SEARCH_PLACEHOLDER: 'Search',
  TABLE_HEADER_FILTER_CLEAR_ALL: 'Clear all',
  TABLE_HEADER_FILTER_SEARCH_EMPTY_TABLE_TITLE: 'No results found',
  TABLE_HEADER_FILTER_SEARCH_EMPTY_TABLE_SUBTITLE: 'Try more general keywords',
  TABLE_STATE_LOADING_RESULTS: 'Loading results...',
  TABLE_STATE_EMPTY_SEARCH_TITLE: 'No results found for',
  TABLE_STATE_EMPTY_SEARCH_SUBTITLE: 'Try again with a different term.',
  TABLE_STATE_EMPTY_FILTER_TITLE: 'No results to display',
  TABLE_STATE_EMPTY_FILTER_SUBTITLE: 'Try again with a different filter',
  TABLE_STATE_EMPTY_FILTER_CTA: 'Clear filters',
  TABLE_HEADER_SELECT_ALL_TOOLTIP: 'Select all',
  TABLE_HEADER_SELECTION_RESUME_COUNT: 'selected.',
  TABLE_HEADER_SELECTION_RESUME_COUNT_plural: 'selected.',
  TABLE_HEADER_SELECTION_RESUME_SELECT_ALL: 'Select all {{count}} items',
  TABLE_HEADER_SELECTION_RESUME_REMOVE_ALL: 'Remove selection',
  TABLE_STATE_EMPTY_WITHOUT_FILTERS: 'No results available yet',
  TABLE_STATE_EMPTY_WITHOUT_FILTERS_SUBTITLE: 'The table has no information to display',
  TABLE_STATE_ERROR_TITLE: 'An error occurred',
  TABLE_STATE_ERROR_SUBTITLE: 'Click the button to try loading again.',
  TABLE_STATE_ERROR_BUTTON_LABEL: 'Retry',
  TABLE_HEADER_ATTRIBUTES_FILTER_APPLY_BUTTON: 'Apply filters',
  TABLE_HEADER_ATTRIBUTES_FILTER_SORT_BUTTON: 'Sort by',
  TABLE_HEADER_ATTRIBUTES_FILTER_SEARCH_PLACEHOLDER: 'Search user attribute',
  TABLE_HEADER_ATTRIBUTES_CUSTOM_FIELDS_COUNT: 'tags',
  TABLE_HEADER_ATTRIBUTES_CLEAR_ALL: 'Clear all',
  TABLE_HEADER_ATTRIBUTES_ATTRIBUTE_ITEM_SHOW_ALL: 'Show all',
  TABLE_HEADER_ATTRIBUTES_EMPTY_SEARCH_TITLE: 'No results found for',
  TABLE_HEADER_ATTRIBUTES_EMPTY_SEARCH_SUBTITLE: 'Try again with a different term.',
  TABLE_HEADER_ATTRIBUTES_DETAIL_BACK_BUTTON: 'Back',
  TABLE_HEADER_ATTRIBUTES_DETAIL_SELECT_ALL: 'Select all',
  TABLE_HEADER_ATTRIBUTES_DETAIL_REMOVE_SELECT_ALL: 'Deselect all',
  TABLE_PAGE_SIZE_SELECTOR_LABEL: 'Items per page:'
};
export default en;